export interface StockItem {
  id: string;
  stockNo: string;
  dateCreated: Date;
  productKey: string;
  productOldCode: string;
  productDescription: string;
  productType: string;
  supplierKey: string;
  supplierName: string;
  imperialStock: boolean;
  balance: number;
  balanceImperial: number;
  totalAllocated: number;
  totalAllocatedImperial: number;
  issued: number;
  issuedImperial: number;
  despatched: number;
  despatchedImperial: number;
  freeStock: number;
  freeStockImperial: number;
  pricePerUnit: number;
  warehouseKey: string;
  warehouseDescription: string;
  locationKey: string;
  locationDescription: string;
  gradeKey: string;
  gradeDescription: string;
  gradeLevel: number;
  makeUpKey: string;
  makeUpDescription: string;
  batchNo: string;
  customerKey: string;
  customerName: string;
  qtyIntoStock: number;
  dateIntoStock: Date;
  reMeasured: boolean;
  externalNo: string;
  calculatedStdCost: number;
  calculatedStdValue: number;
  unitOfMeasure: string;
  commentsExist: boolean;
  colour: string;
}
